export default {
    getDateSecondsFromNow(s) {
        let today = new Date();
        return new Date(today.setSeconds(today.getSeconds() + s));
    },

    getDateSecondsFromDate(s, d) {
        d = new Date(d);
        return new Date(d.setSeconds(d.getSeconds() + s));
    },

    getMonday(d) {
        d = new Date(d);
        var day = d.getDay(),
            diff = d.getDate() - day + (day == 0 ? -6 : 1); // adjust when day is sunday
        return new Date(d.setDate(diff));
    },

    getDateHours(d) {
        return d.getHours() % 12 || 12;
    },

    getDateMinutes(d) {
        if (d.getMinutes() == 0) return '';
        return (d.getMinutes() < 10 ? '0' : '') + d.getMinutes();
    },

    getYesterday() {
        var d = new Date();
        var date = d.getDate();
        return new Date(d.setDate(date - 1));
    },

    getTomorrow() {
        var d = new Date();
        var date = d.getDate();
        return new Date(d.setDate(date + 1));
    },

    isToday(d) {
        const today = new Date();
        return (
            d.getDate() == today.getDate() && d.getMonth() == today.getMonth() && d.getFullYear() == today.getFullYear()
        );
    },

    isWithinMinutesAway(d, m) {
        const total = Date.parse(d) - Date.parse(new Date());

        if (total / 1000 / 60 > m) return false;

        return true;
    },

    isPast(d) {
        return d < new Date();
    }
};
